<template>
  <InformeCard @click="draw" title="Géneros" v-if="totalGeneros.length" id="genero" name="genero" collapsable="true">
        <h4 class="text-center">Estadísticas de Géneros</h4>
        <h6 class="text-center mt-3" v-if="totalGeneros && totalGeneros[1][1] == 0 && totalGeneros[2][1] == 0 && totalGeneros[3][1] == 0">
            No se han recopilado datos de este detalle
        </h6>
        <GChart
            v-else
            type="PieChart"
            :data="totalGeneros"
            :options="chartOptions"
            ref="googleChart"
        />
  </InformeCard>
</template>

<script>
import InformeCard from "../InformeCard";

export default {
    props: ['event_id'],
    data() {
        return {
            totalGeneros: [],
            chartOptions: {
                height: 250,
                chartArea:{width:'100%'}
            }
        }
    },
    methods: {
        getTotalGeneros() {
            const params = {
                filters : {},
                evento_id: this.event_id
            };
            this.$store.dispatch(this.config.getVuexAlias('back.events.informe.total-generos'), params).then(res => {
                this.totalGeneros = res.data;

                this.$emit('totalGeneros', this.totalGeneros);
            });
        },
        draw() {
            if (this.$refs.googleChart) {
                setTimeout(() => {
                    this.$refs.googleChart.drawChart()
                }, 50)
            }
        }
    },
    created() {
        this.getTotalGeneros();
    },
    components: {
        InformeCard
    }
}

</script>